import { PaymentType } from "@utils";
import * as yup from "yup";

import { fetchData } from "@utils/api";
import {
  APIMethods,
  ApiResponse,
  isBadRequestApiError,
} from "@typeDefinitions";

import { IdDto, LangDto, idSchema } from "./common";
import { AxiosError } from "axios";

export const registerClinic = async (
  payload: RegisterClinicRequest,
): Promise<ApiResponse<RegisterClinicResponse>> => {
  const response = await fetchData(
    `/register-clinic`,
    APIMethods.POST,
    payload,
  );
  return registerClinicResponseSchema.validate(response);
};
export interface RegisterClinicRequest {
  firstName: string;
  lastName: string;
  email: string;
  termsOfService: number;
  subscriptionType: string | null;
  paymentType: PaymentType | null;
  lang: LangDto;
  code?: string;
  phoneNumber?: string;
}

export interface RegisterClinicResponse {
  id: number;
  owner: IdDto;
  verificationEmailUrl: string;
}

const clinicResourceSchema = yup.object({
  id: yup.number().required(),
  owner: idSchema.required(),
  verificationEmailUrl: yup.string().required(),
});
export const registerClinicResponseSchema = yup.object({
  data: clinicResourceSchema.required(),
});

export const registerClinicNew = async (
  payload: RegisterClinicNewRequest,
): Promise<ApiResponse<RegisterClinicResponse>> => {
  const response = await fetchData(
    `/register-clinic-new`,
    APIMethods.POST,
    payload,
  );
  return registerClinicResponseSchema.validate(response);
};

export interface RegisterClinicNewRequest {
  firstName: string;
  lastName: string;
  email: string;
  termsOfService: number;
  subscriptionType: string | null;
  paymentType: PaymentType | null;
  lang: LangDto;
  code?: string;
  phoneNumber: string;
  password: string;
  utm?: {
    source: string | null;
    medium: string | null;
    campaign: string | null;
    content: string | null;
    url: string | null;
    term: string | null;
    sourceFirst: string | null;
    mediumFirst: string | null;
    campaignFirst: string | null;
    contentFirst: string | null;
    termFirst: string | null;
    ga4ClientId: string | null;
    pageUrl: string | null;
  };
  newsletter?: boolean;
  userDotComKey: string | null;
  /** IANA time zone, e.g. Europe/Warsaw */
  timezone: string;
}

export const isUniqueEmailBadRequest = (error: AxiosError) => {
  return (
    isBadRequestApiError(error) && error.response?.data.code?.toString() === "1"
  );
};
